var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({class:{
    btn: true,
    active: _vm.active,
    [_vm.themeClassName]: !!_vm.themeClassName,
  },style:(_vm.style),attrs:{"type":"button","disabled":_vm.disabled,"readonly":_vm.readonly},on:{"click":function($event){$event.stopPropagation();!_vm.readonly && !_vm.disabled && _vm.$emit('click')}}},'button',_vm.$props,false),[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"btn_content"},[_vm._t("default")],2),(_vm.loading)?_c('SpinnerLoading',{attrs:{"size":"1.2em"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }